export default "__VITE_ASSET__DxlzlEoZ__"